import React, { useState } from 'react';

/**
 * Componente de sección accordion reutilizable para los visualizadores de expediente.
 * Al hacer clic en el header, la sección se expande o contrae.
 */
const AccordionSection = ({ title, icon, children, defaultOpen = true }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div>
            <div
                className="bg-gradient-to-r from-red-600 to-red-700 px-3 py-2 border-b border-red-200 border-t border-red-200 cursor-pointer select-none"
                onClick={() => setIsOpen(prev => !prev)}
            >
                <div className="flex items-center justify-between">
                    <h3 className="text-xs font-bold text-white uppercase tracking-wider flex items-center gap-1.5">
                        {icon && <span className="material-icons text-sm">{icon}</span>}
                        {title}
                    </h3>
                    <span
                        className="material-icons text-white text-sm transition-transform duration-200"
                        style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }}
                    >
                        expand_more
                    </span>
                </div>
            </div>
            {isOpen && (
                <div className="p-3 space-y-1">
                    {children}
                </div>
            )}
        </div>
    );
};

export default AccordionSection;
